import React, { useState } from 'react';

import { Stack, Text } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import PackageCategoryFilter from 'components/SalesPortal/PackageCategoryFilter';
import PackageSearchFilters from 'components/SalesPortal/PackageSearchFilters';
import SalesPortalHomePagePackages from 'components/SalesPortal/SalesPortalHomePagePackages';
import { useAuth } from 'context/auth-context';
import useSalesPortalConfiguration from 'hooks/salesPortal/useSalesPortalConfiguration';
import useSalesPortalPackageCategories from 'hooks/salesPortal/useSalesPortalPackageCategories';
import useSalesPortalPackages from 'hooks/salesPortal/useSalesPortalPackages';
import Header from 'layouts/SalesPortalLayout/components/Header';
import useSalesPortalKiloClassFromUrlParam from 'pages/sales-portal/useKiloClassFromParam';
import NotFound from 'pages/shared/NotFound';
import { useParams } from 'react-router-dom';
import { PackageCategoryAutoComplete } from 'types';

import SalesPortalKiloClassInfo from './SalesPortalKiloClassInfo';

const SalesPortalHomePage = (): JSX.Element => {
  const { salesPortalSlug } = useParams<{ salesPortalSlug: string }>();
  const { session } = useAuth();

  const [packageCategory, setPackageCategory] = useState<PackageCategoryAutoComplete | null>(null);
  const [search, setSearch] = useState<string>('');
  const [debouncedSearch] = useDebouncedValue<string>(search, 250);

  const { data: salesPortalConfig, isError: salesPortalConfigError } =
    useSalesPortalConfiguration(salesPortalSlug);

  const { kiloClassId } = useSalesPortalKiloClassFromUrlParam();

  const { data: packages, isError: packagesError } = useSalesPortalPackages({
    gym: salesPortalConfig?.data.gym.gymId,
    search: debouncedSearch,
    kiloClassId,
    profileId: session?.profile?.profileId,
  });

  const { data: packageCategoriesData } = useSalesPortalPackageCategories({
    gym: salesPortalConfig?.data.gym.gymId,
  });

  if (salesPortalConfigError || packagesError || (salesPortalConfig && !salesPortalConfig.data.enabled)) {
    return <NotFound />;
  }

  return (
    <>
      <Header logo={salesPortalConfig?.data.logo} gymTitle={salesPortalConfig?.data.gym.title} />
      <Stack className='content-home'>
        <Text fw={600} fz='lg'>
          {salesPortalConfig?.data.homePageText || ''}
        </Text>

        {kiloClassId && <SalesPortalKiloClassInfo />}

        <PackageSearchFilters search={search} setSearch={setSearch} />
        <PackageCategoryFilter
          categories={packageCategoriesData?.data || []}
          packageCategory={packageCategory || null}
          setPackageCategory={setPackageCategory || (() => {})}
        />
        <SalesPortalHomePagePackages
          packages={packages?.data}
          packageCategory={packageCategory}
          setPackageCategory={setPackageCategory}
          gym={salesPortalConfig?.data.gym}
        />
      </Stack>
    </>
  );
};

export default SalesPortalHomePage;
